import { createTheme } from '@one-thd/sui-atomic-components';

const CyberMonday2026PrimaryOne = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

CyberMonday2026PrimaryOne.palette['--sui-palette-background-primary'] = '161 229 79';

export { CyberMonday2026PrimaryOne };